import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Message } from 'src/app/core/class/message';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Router } from '@angular/router';
import { NotifySessionTimeoutComponent } from '../notify-session-timeout/notify-session-timeout.component';
import { Routes } from 'src/app/core/constants/routes';

@Component({
  selector: 'app-warning-session-timeout',
  templateUrl: './warning-session-timeout.component.html',
  styleUrls: ['./warning-session-timeout.component.scss'],
})
export class WarningSessionTimeoutComponent implements OnInit {
  time: number = null;
  timeout: any = null;
  isFromSSO: false;
  public href = '';
  dataBind = ''
  constructor(
    private dialog: MatDialog,
    public message: Message,
    public dialogRef: MatDialogRef<WarningSessionTimeoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private authService: AuthenticationService,
    private router: Router,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = true;
    this.time = Math.floor((Number(this.data) - Number(new Date)) / 1000);
    console.log(this.time)
    // save back link
    this.href = this.router.url;
    if (this.href.includes(Routes.ENTERPRISE_HOME)) {
        this.dataBind = 'enterprise-login';
    }
    else if (this.href.includes('sign-anonymous')) {
      const regxAnonymousUrl = /\/sign-anonymous\/.+\/.+\//gm;
      const regxAnonymousUrlNew = /\/sign-anonymous\/.+\/.+\/.+\//gm;
      const newUrl = regxAnonymousUrl.exec(this.href);
      const newUrlAnonymousLogin = regxAnonymousUrlNew.exec(this.href);
      if(newUrl.length > 0 && !newUrlAnonymousLogin) {
        const loginUrl = newUrl[0];
        const urlDecode = decodeURIComponent(loginUrl);
        this.dataBind = urlDecode;
       } else {
        if(newUrlAnonymousLogin.length > 0) {
          const loginUrl = newUrlAnonymousLogin[0];
          const urlDecode = decodeURIComponent(loginUrl);
          this.dataBind = urlDecode;
        }
       }
    }
    this.checkOldOrNewAnonymousLink(false);
  }

  ngOnInit() {
    this.isFromSSO = JSON.parse(localStorage.getItem('isFromSSO'));
    this.timeout = setInterval(() => {
      this.time -= 1;
      if (this.time == 0) {
        this.dialogRef.close();
        clearInterval(this.timeout);
        this.dialog.open(NotifySessionTimeoutComponent, {
          data: this.dataBind
        });
      }
    }, 1000)
  }

  logoutUser() {
    if (this.href.includes(Routes.ENTERPRISE_HOME)) {
      this.authService.logout();
    } else {
      this.checkOldOrNewAnonymousLink();
    }
    if(this.isFromSSO) {
      window.location.href = this.dataBind;
    }
    else{
      this.router.navigate([this.dataBind]);
    }
    
  }

  onNoClick() {
    clearInterval(this.timeout);
    this.dialogRef.close();
    this.logoutUser();
  }

  onClickRefresh() {
    let refresh = true
    if (this.href.includes('sign-anonymous')) {
      refresh = false
    }
    clearInterval(this.timeout);
    this.dialogRef.close();
    if (!refresh) {
      this.authService.refreshAnonymousToken().subscribe(
        res => {
        },
        err => {
          const timeout = setTimeout(() => {
            this.logoutUser()
          }, 2000)
        });
    } else {
      this.authService.refreshToken().subscribe(res => {
      },
        err => {
          const timeout = setTimeout(() => {
            this.logoutUser()
          }, 2000)
        });
    }
  }
  checkOldOrNewAnonymousLink(isCheckSignAnonymous = true) {
    const regxAnonymousUrl = /\/sign-anonymous\/.+\/.+\//gm;
    const regxAnonymousUrlNew = /\/sign-anonymous\/.+\/.+\/.+\//gm;
    const regxKYCCustom = /\/kyc-customer-identify\/.+\/.+\//gm;
    const regxKYCCamera = /\/kyc-camera-anonymous\/.+\/.+\//gm;
    const regxKYCSign = /\/kyc-sign-anonymous\/.+\/.+\//gm;
    const regxKYC = /\/kyc-confirm-account-anonymous\/.+\/.+\//gm;
    const regxIentifi = /\/identification-method\/.+\/.+\//gm;
    const newUrl = regxAnonymousUrl.exec(this.href);
    const newUrlAnonymousLogin = regxAnonymousUrlNew.exec(this.href);
    const urlKYCCustom = regxKYCCustom.exec(this.href);
    const urlKYCCamera = regxKYCCamera.exec(this.href);
    const urlKYCSign = regxKYCSign.exec(this.href);
    const urlKYC = regxKYC.exec(this.href);
    const urlKYCIentifi = regxIentifi.exec(this.href);
    if (this.href.includes('sign-anonymous')) {
      if(isCheckSignAnonymous) {
        this.authService.anonymousLogout();
      }
      if(newUrl.length > 0 && !newUrlAnonymousLogin) {
        this.dataBind = decodeURIComponent(newUrl[0]);
       } else {
        if(newUrlAnonymousLogin.length > 0) {
           this.dataBind = decodeURIComponent(newUrlAnonymousLogin[0]);
        }
       }
  } else if(this.href.includes(Routes.ENTERPRISE_KYC)) {
      if(this.href.split('/')[4] && (urlKYCCustom || urlKYCCustom || urlKYCCamera || urlKYCSign || urlKYC)) {
        this.dataBind = '/sign-anonymous'+'/'+this.href.split('/')[2]+'/'+this.href.split('/')[3] +'/'+ this.href.split('/')[4];
      }
      else {
        this.dataBind = 'enterprise-login';
      }
    }
  else if(this.href.includes('identification-method')) {
    if(urlKYCIentifi.length) {
      const urlDecode = decodeURIComponent(urlKYCIentifi.input);
      const urlDecodeNew = urlDecode.replace('identification-method', 'sign-anonymous')
      this.dataBind = urlDecodeNew;
    } else {
      this.dataBind ='enterprise-login';
    }
  }
  }
}
